import { oz } from '@weft/utils';
import { CommitmentUsageReportItemSchema } from '../commitment-usage';

export const ProductUsageReportSchema = CommitmentUsageReportItemSchema.extend({
  usageConsumptionCurrencyAmount: oz.number().optional(),
  usageConsumptionUnitsAmount: oz.number().optional(),
  commitmentConsumptionPercentage: oz.number().optional(),
  totalCommitmentCurrencyAmount: oz.number().optional(),
  totalCommitmentUnitsAmount: oz.number().optional(),
}).omit({
  commitmentConsumptionCurrencyAmount: true,
  commitmentConsumptionUnitsAmount: true,
});

export type ProductUsageReport = oz.TypeOf<typeof ProductUsageReportSchema>;